import { RootState } from './store';

export const selectLanguage = (state: RootState) =>
  state.languageSelector.localization;

export const selectLanguageCode = (state: RootState) =>
  state.languageSelector.code;
